import { Route } from 'react-router-dom';
import NotifyMessage from '../components/account-login/notify-message';

export const WrongUserRouter = () => {
  return <Route component={NotifyMessage} path="*" />;
};
